<template>
  <div class="setting">
      <div class="info">
        <div class="head">
          <span class="title">标题(中文)</span>
          <span class="title">标题(英文)</span>
          <span class="title">原类型</span>
          <span class="hidden">显示/隐藏</span>
          <span class="actions">操作</span>
        </div>
        <ul>
          <draggable v-model="info">
            <li v-for="(item,index) in info" :key="index">
              <span class="title">
                {{item.title}}
                <i class="edit el-icon-edit" @click="handleEdit(index, item.title)"></i>
              </span>
              <span class="title_en">
                {{item.title_en}}
                <i class="edit el-icon-edit" @click="handleEditEn(index, item.title_en)"></i>
              </span>
              <span class="title">
                {{typeText[item.type]}}
              </span>
              <span class="hidden">
                <el-switch
                  :value="item.is_hidden"
                  :active-value="0"
                  :inactive-value="1"
                  @change="currentChange(index, item.is_hidden)">
                </el-switch>
              </span>
              <span class="actions">
                <el-button type="text" size="mini" @click="handleUp(index)">上移</el-button>
                <el-button type="text" size="mini" @click="handleDown(index)">下移</el-button>
              </span>
            </li>
          </draggable>
        </ul>
      </div>
      <el-button type="primary" style="margin-top: 10px;" @click="handleOnsubmit">保 存</el-button>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import request from '@/utils/request'
export default {
  name: 'setting',
  components: {
    draggable
  },
  data () {
    return {
      info: [],
      typeText: {
        filmfest: '电影节',
        information: '资讯',
        actor: '演员',
        movie_panorama: '展映',
        movie_track: '剧场',
        people: '人物',
        partner_message: '合作方最新资讯',
        discussion: '讲座',
        offline_ticket: '线下院线'
      }
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      request({
        url: '/ui/movie/info-page-setting'
      }).then(res => {
        this.info = res.data.setting || []
      })
    },
    handleUp(index) {
      if (index === 0) return
      let current = JSON.parse(JSON.stringify(this.info[index]))
      let pre = JSON.parse(JSON.stringify(this.info[index - 1]))
      this.info.splice(index, 1, pre)
      this.info.splice(index - 1, 1, current)
    },
    handleDown(index) {
      if (index === this.info.length - 1) return
      let current = JSON.parse(JSON.stringify(this.info[index]))
      let next = JSON.parse(JSON.stringify(this.info[index + 1]))
      this.info.splice(index, 1, next)
      this.info.splice(index + 1, 1, current)
    },
    handleEdit(index, title) {
      this.$prompt('请输入标题', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: title
      }).then(({ value }) => {
        if (value) {
          this.info[index].title = value;
        }
      }).catch(() => {})
    },
    handleEditEn(index, title) {
      this.$prompt('请输入标题', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: title
      }).then(({ value }) => {
        if (value) {
          this.info[index].title_en = value;
        }
      }).catch(() => {})
    },
    handleOnsubmit() {
      request({
        url: '/ui/movie/info-page-setting',
        method: 'put',
        data: {
          setting: this.info
        }
      }).then(res => {
        this.$message.success('保存成功！')
      })
    },
    currentChange(index, hidden) {
      this.info[index].is_hidden = hidden ? 0 : 1;
    }
  }
}
</script>
<style lang="less" scoped>
.setting {
  .info {
    border: 1px solid #EBEEF5;
    border-bottom: none;
    line-height: 25px;
    .head {
      padding: 10px 0;
      color: #909399;
      font-weight: 700;
      border-bottom: 1px solid #EBEEF5;
      span {
        padding: 0 10px;
        display: inline-block;
        font-size: 14px;
        &.title {
          width: 200px;
        }
        &.hidden {
          width: 200px;
        }
        .actions {
          min-width: 200px;
        }
      }
    }
    li {
      padding: 10px 0;
      color: #444444;
      border-bottom: 1px solid #EBEEF5;
      span {
        padding: 0 10px;
        display: inline-block;
        font-size: 14px;
        &.title, &.title_en {
          width: 200px;
          .edit {
            padding-left: 10px;
            color: #409EFF;
            cursor: pointer;
          }
        }
        &.hidden {
          width: 200px;
        }
        .actions {
          min-width: 200px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/movie/infoPageSetting.vue